// @flow

import stores from 'stores';

export default (updateObj: Object) => {
  return stores.parcelsStore.setParcelCollectionStatus(updateObj);
};
